import { getApiClient } from './ApiClient'

export const permissionModuleListPromise = () => {
  return getApiClient()
    .get('/permission-modules')
    .then(resp => resp.data)
}

// Every admin route key registered at boot, with the module row it resolves to. `gaps` counts the
// ones with no row -- those are reachable by every logged-in admin.
export const permissionModuleRoutesPromise = () => {
  return getApiClient()
    .get('/permission-modules/routes')
    .then(resp => resp.data)
}

export const permissionModuleCreatePromise = (body) => {
  return getApiClient()
    .post('/permission-modules', { body })
    .then(resp => resp.data)
}

export const permissionModuleUpdatePromise = (id, body) => {
  return getApiClient()
    .put(`/permission-modules/${id}`, { body })
    .then(resp => resp.data)
}

export const permissionModuleDeletePromise = (id) => {
  return getApiClient()
    .delete(`/permission-modules/${id}`)
    .then(resp => resp.data)
}
